import { Box, ListItem, MenuItem, styled } from "@mui/material";


export const ProvidersMetricsListWrapper = styled(Box)({
    // overflowY: "scroll",
    // padding: "0 5px",
    height: "100%"
})

export const ProvidersMetricsListItem = styled(MenuItem)({
    // border: "1px solid red",
    minHeight: "45px",
    display: "flex",
    alignItems: "center",
    padding: "0 5px 0 0",
    whiteSpace: "normal"
})